<template>
  <b-container fluid>
    <b-modal
      v-model="isShow"
      size="lg"
      scrollable
      id="modal-1"
      hide-footer
      centered
      ref="modal"
      @hidden="resetForm()"
    >
      <template #modal-header="{ close }">
        <h5>Bổ sung hồ sơ theo cam kết</h5>
        <div class="float-right">
          <button type="button" @click="resetForm()" class="btn btn-light ml-2">Huỷ</button>
          <button type="button" @click="submitForm()" class="btn btn-light ml-2">Lưu</button>
        </div>
        <span v-show="error">{{ error }}</span>
      </template>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <b-form @submit.stop>
          <div class="form">
            <div class="col-md-8">
              <div class="m-b-10 m-t-20" style="border: 1px solid"></div>
              <h6>Cam kết bổ sung</h6>
              <ValidationProvider
                rules="required|note_1000"
                vid="note"
                name="Ghi chú cam kết bổ sung sau"
                :persist="true"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-3 col-form-label"
                    >Ghi chú cam kết bổ sung sau <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <textarea
                      class="form-control"
                      v-model.trim="form.note"
                      placeholder="Nhập thông tin ghi chú cam kết bổ sung sau"
                      rows="3"
                      style="resize: none"
                    ></textarea>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="img" name="Ảnh BS cam kết" :persist="true">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-3 col-form-label"
                    >Ảnh BS cam kết<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input type="hidden" v-model="form.img" />
                    <UploadMultiple
                      @syncFile="syncFileAdditionalImg"
                      :lsData="additionalImg"
                      :maxFile="20"
                      uniqueKey="images"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-4"></div>
          </div>
        </b-form>
      </ValidationObserver>
    </b-modal>
    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true"> </VueLoadingOverlay>
  </b-container>
</template>

<script>
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { ContractService } from '@/services/contract.service'
  import { CommonService } from '@/services/common.service'

  export default {
    components: { UploadMultiple },
    data() {
      return {
        isShow: false,
        isLoading: false,
        info: {},
        id: '',
        error: '',
        form: {},
        additionalImg: [],
      }
    },
    methods: {
      async submitForm() {
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return

        this.isLoading = true
        this.error = ''

        try {
          const params = {
            id: this.id,
            img: this.img,
            note: this.form.note,
          }

          const files = await Promise.all(this.additionalImg.map(s => this.sendFile(s))).catch(
            e => {
              return []
            }
          )

          if (files.length == 0) {
            this.error = 'Có lỗi xảy ra trong quá trình upload ảnh'
            this.isLoading = false
            return
          }
          params.img = files.map(s => s.urlFile)

          const response = await ContractService.updateProfileMerchantKeyOnus(params)
          if (response.success) {
            this.showSuccessMx('Thành công')
            this.isShow = false
            this.$emit('success')
          } else {
            this.error = response.message
          }
        } catch (error) {
          this.error = error.message ?? error
        } finally {
          this.isLoading = false
        }
      },
      resetForm() {
        this.isShow = false
        this.form = {}
        this.info = {}
        this.id = ''
        this.error = ''
        this.additionalImg = []
      },

      show(item) {
        this.isShow = true
        this.$nextTick(() => {
          this.$refs.observer.reset()
        })
        this.info = item || {}
        this.id = item.id ?? ''
        if (item.additionalImg && item.additionalImg.length > 0) {
          this.form.img = item.additionalImg
          this.additionalImg = item.additionalImg
        }
        this.form.note = item.additionalCommitmentNote ?? ''
      },
      syncFileAdditionalImg(files) {
        this.additionalImg = files
        if (Object.keys(files).length > 0) {
          this.form.img = files
        } else {
          delete this.form.img
        }
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', `merchant/${this.info.merchant.id}/files`)
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else {
          if (item.url) {
            return { urlFile: item.url }
          }

          return { urlFile: item }
        }
      },
    },
  }
</script>

<style scoped>
  .btn {
    & + .btn {
      margin-left: 6px;
    }
  }

  ::v-deep .modal-header {
    border-bottom: none;
  }
</style>
